import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_PROTECTION_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

// The Console page that explains the fee (the same one the footer links to). The copy is
// long, so the icon links out to it instead of squeezing it into a tooltip (P25028-185).
// A new tab keeps the buyer's checkout where it was. NamedLink drops `target`, hence <a>.
const PROTECTION_FEE_PAGE_PATH = '/pages/causee-protection-fee';

const IconInfo = () => (
  <svg className={css.infoIcon} width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
    <circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path d="M8 7v4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <circle cx="8" cy="4.75" r="0.9" fill="currentColor" />
  </svg>
);

const LineItemProtectionFeeMaybe = props => {
  const { lineItems, intl } = props;

  const protectionFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_PROTECTION_FEE && !item.reversal
  );

  const infoLabel = intl.formatMessage({ id: 'OrderBreakdown.protectionFeeInfo' });

  return protectionFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.protectionFee" />
        <a
          className={css.infoLink}
          href={PROTECTION_FEE_PAGE_PATH}
          target="_blank"
          rel="noopener noreferrer"
          title={infoLabel}
          aria-label={infoLabel}
        >
          <IconInfo />
        </a>
      </span>
      <span className={css.itemValue}>{formatMoney(intl, protectionFeeLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemProtectionFeeMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemProtectionFeeMaybe;
